module.exports = __webpack_public_path__ + "static/media/01.f06c9045.jpg";